// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Model
import { useFormSubmissionDetailsItemDataID } from '@lyon/scoped-models/answer/FormSubmissionDetailsItem';
import { FormSubmissionQuestions } from '@lyon/scoped-models/answer/FormSubmissionQuestions';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';
import { LyonViewAnswerFormDetails } from './LyonViewAnswerFormDetails';
import { LyonViewAnswerFormQuestions } from './LyonViewAnswerFormQuestions';

export const LyonViewAnswerFormBody = constant(() => {
  const id = useFormSubmissionDetailsItemDataID();

  if (!id) {
    return <Loader />;
  }

  return (
    <Block
      display="flex"
      width="100%"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <LyonViewAnswerFormDetails />
      <FormSubmissionQuestions.Provider id={id}>
        <LyonViewAnswerFormQuestions />
      </FormSubmissionQuestions.Provider>
    </Block>
  );
});
